import React from 'react';
import { FadeIn } from './ui/FadeIn';

const testimonials = [
  {
    text: "The leads were clean, well-organized, and the emails actually worked. Less than 1% bounce rate on a list of 500. I've tried three other sellers before, Musa is the one I kept coming back to.",
    author: "Founder, B2B SaaS Company (US)"
  },
  {
    text: "I gave him a very specific ICP, marketing directors at mid-market retail companies in the Northeast. He nailed it. Every lead was relevant, verified, and delivered ahead of schedule.",
    author: "Head of Sales, Digital Agency (UK)"
  },
  {
    text: "We needed 1,000 real estate investor contacts in DFW with direct phone numbers. He delivered 1,050 with a 72% phone match rate. We closed 3 deals from that list in the first two months.",
    author: "Managing Partner, Real Estate Investment Firm (Texas)"
  }
];

export function Results() {
  return (
    <section className="py-section-mob md:py-section-desk bg-paper">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <FadeIn>
          <h2 className="font-heading text-h2-mob md:text-h2-desk text-ink mb-16 md:mb-24 text-center">
            What clients say
          </h2>
        </FadeIn>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {testimonials.map((t, idx) => (
            <FadeIn key={idx} delay={idx * 0.1} className="flex flex-col">
              <div className="mb-8">
                <p className="font-heading italic text-[22px] leading-relaxed text-ink">
                  "{t.text}"
                </p>
              </div>
              <div className="mt-auto pt-6 border-t border-hairline">
                <p className="font-mono text-[13px] text-graphite uppercase">
                  , {t.author}
                </p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}